function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { refineProps, guid, parseBusinessHours, createEventUi, identity, parseClassNames, EventImpl, parseFieldSpecs, BaseComponent, memoizeObjArg, ViewContextType, ContentContainer, formatDayString, memoize, NowTimer, TableDateCell, TableDowCell, computeFallbackHeaderFormat, Splitter, mapHash, flexibleCompare, compareByFieldSpecs } from '@fullcalendar/core/internal.js';
import { createElement, Fragment } from '@fullcalendar/core/preact.js';
var PRIVATE_ID_PREFIX = '_fc:';
var RESOURCE_REFINERS = {
  id: String,
  parentId: String,
  children: identity,
  title: String,
  businessHours: identity,
  extendedProps: identity,
  // event-ui
  eventEditable: Boolean,
  eventStartEditable: Boolean,
  eventDurationEditable: Boolean,
  eventConstraint: identity,
  eventOverlap: Boolean,
  eventAllow: identity,
  eventClassNames: parseClassNames,
  eventBackgroundColor: String,
  eventBorderColor: String,
  eventTextColor: String,
  eventColor: String
};
/*
needs a full store so that it can populate children too
*/

function parseResource(raw) {
  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var store = arguments.length > 2 ? arguments[2] : undefined;
  var context = arguments.length > 3 ? arguments[3] : undefined;

  var _refineProps = refineProps(raw, RESOURCE_REFINERS),
      refined = _refineProps.refined,
      extra = _refineProps.extra;

  var resource = {
    id: refined.id || PRIVATE_ID_PREFIX + guid(),
    parentId: refined.parentId || parentId,
    title: refined.title || '',
    businessHours: refined.businessHours ? parseBusinessHours(refined.businessHours, context) : null,
    ui: createEventUi({
      editable: refined.eventEditable,
      startEditable: refined.eventStartEditable,
      durationEditable: refined.eventDurationEditable,
      constraint: refined.eventConstraint,
      overlap: refined.eventOverlap,
      allow: refined.eventAllow,
      classNames: refined.eventClassNames,
      backgroundColor: refined.eventBackgroundColor,
      borderColor: refined.eventBorderColor,
      textColor: refined.eventTextColor,
      color: refined.eventColor
    }, context),
    extendedProps: Object.assign(Object.assign({}, extra), refined.extendedProps)
  }; // help out ResourceApi from having user modify props

  Object.freeze(resource.ui.classNames);
  Object.freeze(resource.extendedProps);
  if (store[resource.id]) ;else {
    store[resource.id] = resource;

    if (refined.children) {
      var _iterator = _createForOfIteratorHelper(refined.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var childInput = _step.value;
          parseResource(childInput, resource.id, store, context);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  return resource;
}
/*
TODO: use this in more places
*/


function getPublicId(id) {
  if (id.indexOf(PRIVATE_ID_PREFIX) === 0) {
    return '';
  }

  return id;
}

var ResourceApi = /*#__PURE__*/function () {
  function ResourceApi(_context, _resource) {
    _classCallCheck(this, ResourceApi);

    this._context = _context;
    this._resource = _resource;
  }

  _createClass(ResourceApi, [{
    key: "setProp",
    value: function setProp(name, value) {
      var oldResource = this._resource;

      this._context.dispatch({
        type: 'SET_RESOURCE_PROP',
        resourceId: oldResource.id,
        propName: name,
        propValue: value
      });

      this.sync(oldResource);
    }
  }, {
    key: "setExtendedProp",
    value: function setExtendedProp(name, value) {
      var oldResource = this._resource;

      this._context.dispatch({
        type: 'SET_RESOURCE_EXTENDED_PROP',
        resourceId: oldResource.id,
        propName: name,
        propValue: value
      });

      this.sync(oldResource);
    }
  }, {
    key: "sync",
    value: function sync(oldResource) {
      var context = this._context;
      var resourceId = oldResource.id; // TODO: what if dispatch didn't complete synchronously?

      this._resource = context.getCurrentData().resourceStore[resourceId];
      context.emitter.trigger('resourceChange', {
        oldResource: new ResourceApi(context, oldResource),
        resource: this,
        revert: function revert() {
          context.dispatch({
            type: 'ADD_RESOURCE',
            resourceHash: _defineProperty({}, resourceId, oldResource)
          });
        }
      });
    }
  }, {
    key: "remove",
    value: function remove() {
      var context = this._context;
      var internalResource = this._resource;
      var resourceId = internalResource.id;
      context.dispatch({
        type: 'REMOVE_RESOURCE',
        resourceId: resourceId
      });
      context.emitter.trigger('resourceRemove', {
        resource: this,
        revert: function revert() {
          context.dispatch({
            type: 'ADD_RESOURCE',
            resourceHash: _defineProperty({}, resourceId, internalResource)
          });
        }
      });
    }
  }, {
    key: "getParent",
    value: function getParent() {
      var context = this._context;
      var parentId = this._resource.parentId;

      if (parentId) {
        return new ResourceApi(context, context.getCurrentData().resourceStore[parentId]);
      }

      return null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var thisResourceId = this._resource.id;
      var context = this._context;

      var _context$getCurrentDa = context.getCurrentData(),
          resourceStore = _context$getCurrentDa.resourceStore;

      var childApis = [];

      for (var resourceId in resourceStore) {
        if (resourceStore[resourceId].parentId === thisResourceId) {
          childApis.push(new ResourceApi(context, resourceStore[resourceId]));
        }
      }

      return childApis;
    }
    /*
    this is really inefficient!
    TODO: make EventApi::resourceIds a hash or keep an index in the Calendar's state
    */

  }, {
    key: "getEvents",
    value: function getEvents() {
      var thisResourceId = this._resource.id;
      var context = this._context;
      var _context$getCurrentDa2 = context.getCurrentData().eventStore,
          defs = _context$getCurrentDa2.defs,
          instances = _context$getCurrentDa2.instances;
      var eventApis = [];

      for (var instanceId in instances) {
        var instance = instances[instanceId];
        var def = defs[instance.defId];

        if (def.resourceIds.indexOf(thisResourceId) !== -1) {
          // inefficient!!!
          eventApis.push(new EventImpl(context, def, instance));
        }
      }

      return eventApis;
    }
  }, {
    key: "toPlainObject",
    value: function toPlainObject() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var internal = this._resource;
      var ui = internal.ui;
      var publicId = this.id;
      var res = {};

      if (publicId) {
        res.id = publicId;
      }

      if (internal.title) {
        res.title = internal.title;
      }

      if (settings.collapseEventColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
        res.eventColor = ui.backgroundColor;
      } else {
        if (ui.backgroundColor) {
          res.eventBackgroundColor = ui.backgroundColor;
        }

        if (ui.borderColor) {
          res.eventBorderColor = ui.borderColor;
        }
      }

      if (ui.textColor) {
        res.eventTextColor = ui.textColor;
      }

      if (ui.classNames.length) {
        res.eventClassNames = ui.classNames;
      }

      if (Object.keys(internal.extendedProps).length) {
        if (settings.collapseExtendedProps) {
          Object.assign(res, internal.extendedProps);
        } else {
          res.extendedProps = internal.extendedProps;
        }
      }

      return res;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toPlainObject();
    }
  }, {
    key: "id",
    get: function get() {
      return getPublicId(this._resource.id);
    }
  }, {
    key: "title",
    get: function get() {
      return this._resource.title;
    }
  }, {
    key: "eventConstraint",
    get: function get() {
      return this._resource.ui.constraints[0] || null;
    } // TODO: better type

  }, {
    key: "eventOverlap",
    get: function get() {
      return this._resource.ui.overlap;
    }
  }, {
    key: "eventAllow",
    get: function get() {
      return this._resource.ui.allows[0] || null;
    } // TODO: better type

  }, {
    key: "eventBackgroundColor",
    get: function get() {
      return this._resource.ui.backgroundColor;
    }
  }, {
    key: "eventBorderColor",
    get: function get() {
      return this._resource.ui.borderColor;
    }
  }, {
    key: "eventTextColor",
    get: function get() {
      return this._resource.ui.textColor;
    } // NOTE: user can't modify these because Object.freeze was called in event-def parsing

  }, {
    key: "eventClassNames",
    get: function get() {
      return this._resource.ui.classNames;
    }
  }, {
    key: "extendedProps",
    get: function get() {
      return this._resource.extendedProps;
    }
  }]);

  return ResourceApi;
}();

function buildResourceApis(resourceStore, context) {
  var resourceApis = [];

  for (var resourceId in resourceStore) {
    resourceApis.push(new ResourceApi(context, resourceStore[resourceId]));
  }

  return resourceApis;
}

function refineRenderProps$1(input) {
  return {
    resource: new ResourceApi(input.context, input.resource)
  };
}

var DEFAULT_RESOURCE_ORDER = parseFieldSpecs('id,title');

function handleResourceStore(resourceStore, calendarData) {
  var emitter = calendarData.emitter;

  if (emitter.hasHandlers('resourcesSet')) {
    emitter.trigger('resourcesSet', buildResourceApis(resourceStore, calendarData));
  }
} // TODO: not used for Spreadsheet. START USING. difficult because of col-specific rendering props


var ResourceLabelContainer = /*#__PURE__*/function (_BaseComponent) {
  _inherits(ResourceLabelContainer, _BaseComponent);

  var _super = _createSuper(ResourceLabelContainer);

  function ResourceLabelContainer() {
    var _this;

    _classCallCheck(this, ResourceLabelContainer);

    _this = _super.apply(this, arguments);
    _this.refineRenderProps = memoizeObjArg(refineRenderProps);
    return _this;
  }

  _createClass(ResourceLabelContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return createElement(ViewContextType.Consumer, null, function (context) {
        var options = context.options;

        var renderProps = _this2.refineRenderProps({
          resource: props.resource,
          date: props.date,
          context: context
        });

        return createElement(ContentContainer, Object.assign({}, props, {
          elAttrs: Object.assign(Object.assign({}, props.elAttrs), {
            'data-resource-id': props.resource.id,
            'data-date': props.date ? formatDayString(props.date) : undefined
          }),
          renderProps: renderProps,
          generatorName: "resourceLabelContent",
          customGenerator: options.resourceLabelContent,
          defaultGenerator: renderInnerContent,
          classNameGenerator: options.resourceLabelClassNames,
          didMount: options.resourceLabelDidMount,
          willUnmount: options.resourceLabelWillUnmount
        }));
      });
    }
  }]);

  return ResourceLabelContainer;
}(BaseComponent);

function renderInnerContent(props) {
  return props.resource.title || props.resource.id;
}

function refineRenderProps(input) {
  return {
    resource: new ResourceApi(input.context, input.resource),
    date: input.date ? input.context.dateEnv.toDate(input.date) : null,
    view: input.context.viewApi
  };
}

var ResourceCell = /*#__PURE__*/function (_BaseComponent2) {
  _inherits(ResourceCell, _BaseComponent2);

  var _super2 = _createSuper(ResourceCell);

  function ResourceCell() {
    _classCallCheck(this, ResourceCell);

    return _super2.apply(this, arguments);
  }

  _createClass(ResourceCell, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return createElement(ResourceLabelContainer, {
        elTag: "th",
        elClasses: ['fc-col-header-cell', 'fc-resource'],
        elAttrs: {
          role: 'columnheader',
          colSpan: props.colSpan
        },
        resource: props.resource,
        date: props.date
      }, function (InnerContent) {
        return createElement("div", {
          className: "fc-scrollgrid-sync-inner"
        }, createElement(InnerContent, {
          elTag: "span",
          elClasses: ['fc-col-header-cell-cushion', props.isSticky && 'fc-sticky']
        }));
      });
    }
  }]);

  return ResourceCell;
}(BaseComponent);

var ResourceDayHeader = /*#__PURE__*/function (_BaseComponent3) {
  _inherits(ResourceDayHeader, _BaseComponent3);

  var _super3 = _createSuper(ResourceDayHeader);

  function ResourceDayHeader() {
    var _this3;

    _classCallCheck(this, ResourceDayHeader);

    _this3 = _super3.apply(this, arguments);
    _this3.buildDateFormat = memoize(buildDateFormat);
    return _this3;
  }

  _createClass(ResourceDayHeader, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props,
          context = this.context;
      var dateFormat = this.buildDateFormat(context.options.dayHeaderFormat, props.datesRepDistinctDays, props.dates.length);
      return createElement(NowTimer, {
        unit: "day"
      }, function (nowDate, todayRange) {
        if (props.dates.length === 1) {
          return _this4.renderResourceRow(props.resources, props.dates[0]);
        }

        if (context.options.datesAboveResources) {
          return _this4.renderDayAndResourceRows(props.dates, dateFormat, todayRange, props.resources);
        }

        return _this4.renderResourceAndDayRows(props.resources, props.dates, dateFormat, todayRange);
      });
    }
  }, {
    key: "renderResourceRow",
    value: function renderResourceRow(resources, date) {
      var resourceCells = resources.map(function (resource) {
        return createElement(ResourceCell, {
          key: resource.id,
          resource: resource,
          colSpan: 1,
          date: date
        });
      });
      return this.buildTr(resourceCells, 'resources');
    }
  }, {
    key: "renderDayAndResourceRows",
    value: function renderDayAndResourceRows(dates, dateFormat, todayRange, resources) {
      var dateCells = [];
      var resourceCells = [];

      var _iterator2 = _createForOfIteratorHelper(dates),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var date = _step2.value;
          dateCells.push(this.renderDateCell(date, dateFormat, todayRange, resources.length, null, true));

          var _iterator3 = _createForOfIteratorHelper(resources),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var resource = _step3.value;
              resourceCells.push(createElement(ResourceCell, {
                key: resource.id + ':' + date.toISOString(),
                resource: resource,
                colSpan: 1,
                date: date
              }));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return createElement(Fragment, null, this.buildTr(dateCells, 'day'), this.buildTr(resourceCells, 'resources'));
    }
  }, {
    key: "renderResourceAndDayRows",
    value: function renderResourceAndDayRows(resources, dates, dateFormat, todayRange) {
      var resourceCells = [];
      var dateCells = [];

      var _iterator4 = _createForOfIteratorHelper(resources),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var resource = _step4.value;
          resourceCells.push(createElement(ResourceCell, {
            key: resource.id,
            resource: resource,
            colSpan: dates.length,
            isSticky: true
          }));

          var _iterator5 = _createForOfIteratorHelper(dates),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var date = _step5.value;
              dateCells.push(this.renderDateCell(date, dateFormat, todayRange, 1, resource));
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return createElement(Fragment, null, this.buildTr(resourceCells, 'resources'), this.buildTr(dateCells, 'day'));
    } // a cell with date text. might have a resource associated with it

  }, {
    key: "renderDateCell",
    value: function renderDateCell(date, dateFormat, todayRange, colSpan, resource, isSticky) {
      var props = this.props;
      var keyPostfix = resource ? ":".concat(resource.id) : '';
      var extraRenderProps = resource ? {
        resource: new ResourceApi(this.context, resource)
      } : {};
      var extraDataAttrs = resource ? {
        'data-resource-id': resource.id
      } : {};
      return props.datesRepDistinctDays ? createElement(TableDateCell, {
        key: date.toISOString() + keyPostfix,
        date: date,
        dateProfile: props.dateProfile,
        todayRange: todayRange,
        colCnt: props.dates.length * props.resources.length,
        dayHeaderFormat: dateFormat,
        colSpan: colSpan,
        isSticky: isSticky,
        extraRenderProps: extraRenderProps,
        extraDataAttrs: extraDataAttrs
      }) : createElement(TableDowCell // we can't leverage the pure-componentness becausae the extra* props are new every time :(
      , {
        key: date.getUTCDay() + keyPostfix,
        dow: date.getUTCDay(),
        dayHeaderFormat: dateFormat,
        colSpan: colSpan,
        isSticky: isSticky,
        extraRenderProps: extraRenderProps,
        extraDataAttrs: extraDataAttrs
      });
    }
  }, {
    key: "buildTr",
    value: function buildTr(cells, key) {
      var renderIntro = this.props.renderIntro;

      if (!cells.length) {
        cells = [createElement("td", {
          key: 0
        }, "\xA0")];
      }

      return createElement("tr", {
        key: key,
        role: "row"
      }, renderIntro && renderIntro(key), cells);
    }
  }]);

  return ResourceDayHeader;
}(BaseComponent);

function buildDateFormat(dayHeaderFormat, datesRepDistinctDays, dayCnt) {
  return dayHeaderFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt);
}

var ResourceIndex = function ResourceIndex(resources) {
  _classCallCheck(this, ResourceIndex);

  var indicesById = {};
  var ids = [];

  for (var i = 0; i < resources.length; i += 1) {
    var id = resources[i].id;
    ids.push(id);
    indicesById[id] = i;
  }

  this.ids = ids;
  this.indicesById = indicesById;
  this.length = resources.length;
};

var AbstractResourceDayTableModel = /*#__PURE__*/function () {
  function AbstractResourceDayTableModel(dayTableModel, resources, context) {
    _classCallCheck(this, AbstractResourceDayTableModel);

    this.dayTableModel = dayTableModel;
    this.resources = resources;
    this.context = context;
    this.resourceIndex = new ResourceIndex(resources);
    this.rowCnt = dayTableModel.rowCnt;
    this.colCnt = dayTableModel.colCnt * resources.length;
    this.cells = this.buildCells();
  }

  _createClass(AbstractResourceDayTableModel, [{
    key: "buildCells",
    value: function buildCells() {
      var rowCnt = this.rowCnt,
          dayTableModel = this.dayTableModel,
          resources = this.resources;
      var rows = [];

      for (var row = 0; row < rowCnt; row += 1) {
        var rowCells = [];

        for (var dateCol = 0; dateCol < dayTableModel.colCnt; dateCol += 1) {
          for (var resourceCol = 0; resourceCol < resources.length; resourceCol += 1) {
            var resource = resources[resourceCol];
            var extraRenderProps = {
              resource: new ResourceApi(this.context, resource)
            };
            var extraDataAttrs = {
              'data-resource-id': resource.id
            };
            var extraClassNames = ['fc-resource'];
            var extraDateSpan = {
              resourceId: resource.id
            };
            var date = dayTableModel.cells[row][dateCol].date;
            rowCells[this.computeCol(dateCol, resourceCol)] = {
              key: resource.id + ':' + date.toISOString(),
              date: date,
              extraRenderProps: extraRenderProps,
              extraDataAttrs: extraDataAttrs,
              extraClassNames: extraClassNames,
              extraDateSpan: extraDateSpan
            };
          }
        }

        rows.push(rowCells);
      }

      return rows;
    }
  }]);

  return AbstractResourceDayTableModel;
}();
/*
resources over dates
*/


var ResourceDayTableModel = /*#__PURE__*/function (_AbstractResourceDayT) {
  _inherits(ResourceDayTableModel, _AbstractResourceDayT);

  var _super4 = _createSuper(ResourceDayTableModel);

  function ResourceDayTableModel() {
    _classCallCheck(this, ResourceDayTableModel);

    return _super4.apply(this, arguments);
  }

  _createClass(ResourceDayTableModel, [{
    key: "computeCol",
    value: function computeCol(dateI, resourceI) {
      return resourceI * this.dayTableModel.colCnt + dateI;
    }
    /*
    all date ranges are intact
    */

  }, {
    key: "computeColRanges",
    value: function computeColRanges(dateStartI, dateEndI, resourceI) {
      return [{
        firstCol: this.computeCol(dateStartI, resourceI),
        lastCol: this.computeCol(dateEndI, resourceI),
        isStart: true,
        isEnd: true
      }];
    }
  }]);

  return ResourceDayTableModel;
}(AbstractResourceDayTableModel);
/*
dates over resources
*/


var DayResourceTableModel = /*#__PURE__*/function (_AbstractResourceDayT2) {
  _inherits(DayResourceTableModel, _AbstractResourceDayT2);

  var _super5 = _createSuper(DayResourceTableModel);

  function DayResourceTableModel() {
    _classCallCheck(this, DayResourceTableModel);

    return _super5.apply(this, arguments);
  }

  _createClass(DayResourceTableModel, [{
    key: "computeCol",
    value: function computeCol(dateI, resourceI) {
      return dateI * this.resources.length + resourceI;
    }
    /*
    every single day is broken up
    */

  }, {
    key: "computeColRanges",
    value: function computeColRanges(dateStartI, dateEndI, resourceI) {
      var segs = [];

      for (var i = dateStartI; i <= dateEndI; i += 1) {
        var col = this.computeCol(i, resourceI);
        segs.push({
          firstCol: col,
          lastCol: col,
          isStart: i === dateStartI,
          isEnd: i === dateEndI
        });
      }

      return segs;
    }
  }]);

  return DayResourceTableModel;
}(AbstractResourceDayTableModel);

var NO_SEGS = []; // for memoizing

var VResourceJoiner = /*#__PURE__*/function () {
  function VResourceJoiner() {
    _classCallCheck(this, VResourceJoiner);

    this.joinDateSelection = memoize(this.joinSegs);
    this.joinBusinessHours = memoize(this.joinSegs);
    this.joinFgEvents = memoize(this.joinSegs);
    this.joinBgEvents = memoize(this.joinSegs);
    this.joinEventDrags = memoize(this.joinInteractions);
    this.joinEventResizes = memoize(this.joinInteractions);
  }
  /*
  propSets also has a '' key for things with no resource
  */


  _createClass(VResourceJoiner, [{
    key: "joinProps",
    value: function joinProps(propSets, resourceDayTable) {
      var dateSelectionSets = [];
      var businessHoursSets = [];
      var fgEventSets = [];
      var bgEventSets = [];
      var eventDrags = [];
      var eventResizes = [];
      var eventSelection = '';
      var keys = resourceDayTable.resourceIndex.ids.concat(['']); // add in the all-resource key

      var _iterator6 = _createForOfIteratorHelper(keys),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value;
          var props = propSets[key];
          dateSelectionSets.push(props.dateSelectionSegs);
          businessHoursSets.push(key ? props.businessHourSegs : NO_SEGS); // don't include redundant all-resource businesshours

          fgEventSets.push(key ? props.fgEventSegs : NO_SEGS); // don't include fg all-resource segs

          bgEventSets.push(props.bgEventSegs);
          eventDrags.push(props.eventDrag);
          eventResizes.push(props.eventResize);
          eventSelection = eventSelection || props.eventSelection;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return {
        dateSelectionSegs: this.joinDateSelection.apply(this, [resourceDayTable].concat(dateSelectionSets)),
        businessHourSegs: this.joinBusinessHours.apply(this, [resourceDayTable].concat(businessHoursSets)),
        fgEventSegs: this.joinFgEvents.apply(this, [resourceDayTable].concat(fgEventSets)),
        bgEventSegs: this.joinBgEvents.apply(this, [resourceDayTable].concat(bgEventSets)),
        eventDrag: this.joinEventDrags.apply(this, [resourceDayTable].concat(eventDrags)),
        eventResize: this.joinEventResizes.apply(this, [resourceDayTable].concat(eventResizes)),
        eventSelection: eventSelection
      };
    }
  }, {
    key: "joinSegs",
    value: function joinSegs(resourceDayTable) {
      var resourceCnt = resourceDayTable.resources.length;
      var transformedSegs = [];

      for (var _len = arguments.length, segGroups = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        segGroups[_key - 1] = arguments[_key];
      }

      for (var i = 0; i < resourceCnt; i += 1) {
        var _iterator7 = _createForOfIteratorHelper(segGroups[i]),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var seg = _step7.value;
            transformedSegs.push.apply(transformedSegs, _toConsumableArray(this.transformSeg(seg, resourceDayTable, i)));
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var _iterator8 = _createForOfIteratorHelper(segGroups[resourceCnt]),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _seg = _step8.value;
            // one beyond. the all-resource
            transformedSegs.push.apply(transformedSegs, _toConsumableArray(this.transformSeg(_seg, resourceDayTable, i)));
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }

      return transformedSegs;
    }
    /*
    for expanding non-resource segs to all resources.
    only for public use.
    no memoizing.
    */

  }, {
    key: "expandSegs",
    value: function expandSegs(resourceDayTable, segs) {
      var resourceCnt = resourceDayTable.resources.length;
      var transformedSegs = [];

      for (var i = 0; i < resourceCnt; i += 1) {
        var _iterator9 = _createForOfIteratorHelper(segs),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var seg = _step9.value;
            transformedSegs.push.apply(transformedSegs, _toConsumableArray(this.transformSeg(seg, resourceDayTable, i)));
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }

      return transformedSegs;
    }
  }, {
    key: "joinInteractions",
    value: function joinInteractions(resourceDayTable) {
      var resourceCnt = resourceDayTable.resources.length;
      var affectedInstances = {};
      var transformedSegs = [];
      var anyInteractions = false;
      var isEvent = false;

      for (var _len2 = arguments.length, interactions = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        interactions[_key2 - 1] = arguments[_key2];
      }

      for (var i = 0; i < resourceCnt; i += 1) {
        var interaction = interactions[i];

        if (interaction) {
          anyInteractions = true;

          var _iterator10 = _createForOfIteratorHelper(interaction.segs),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var seg = _step10.value;
              transformedSegs.push.apply(transformedSegs, _toConsumableArray(this.transformSeg(seg, resourceDayTable, i)));
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }

          Object.assign(affectedInstances, interaction.affectedInstances);
          isEvent = isEvent || interaction.isEvent;
        }

        if (interactions[resourceCnt]) {
          // one beyond. the all-resource
          var _iterator11 = _createForOfIteratorHelper(interactions[resourceCnt].segs),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _seg2 = _step11.value;
              transformedSegs.push.apply(transformedSegs, _toConsumableArray(this.transformSeg(_seg2, resourceDayTable, i)));
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        }
      }

      if (anyInteractions) {
        return {
          affectedInstances: affectedInstances,
          segs: transformedSegs,
          isEvent: isEvent
        };
      }

      return null;
    }
  }]);

  return VResourceJoiner;
}();
/*
TODO: just use ResourceHash somehow? could then use the generic ResourceSplitter
*/


var VResourceSplitter = /*#__PURE__*/function (_Splitter) {
  _inherits(VResourceSplitter, _Splitter);

  var _super6 = _createSuper(VResourceSplitter);

  function VResourceSplitter() {
    _classCallCheck(this, VResourceSplitter);

    return _super6.apply(this, arguments);
  }

  _createClass(VResourceSplitter, [{
    key: "getKeyInfo",
    value: function getKeyInfo(props) {
      var resourceDayTableModel = props.resourceDayTableModel;
      var hash = mapHash(resourceDayTableModel.resourceIndex.indicesById, function (i) {
        return resourceDayTableModel.resources[i];
      }); // :(

      hash[''] = {};
      return hash;
    }
  }, {
    key: "getKeysForDateSpan",
    value: function getKeysForDateSpan(dateSpan) {
      return [dateSpan.resourceId || ''];
    }
  }, {
    key: "getKeysForEventDef",
    value: function getKeysForEventDef(eventDef) {
      var resourceIds = eventDef.resourceIds;

      if (!resourceIds.length) {
        return [''];
      }

      return resourceIds;
    }
  }]);

  return VResourceSplitter;
}(Splitter);
/*
doesn't accept grouping
*/


function flattenResources(resourceStore, orderSpecs) {
  return buildRowNodes(resourceStore, [], orderSpecs, false, {}, true).map(function (node) {
    return node.resource;
  });
}

function buildRowNodes(resourceStore, groupSpecs, orderSpecs, isVGrouping, expansions, expansionDefault) {
  var complexNodes = buildHierarchy(resourceStore, isVGrouping ? -1 : 1, groupSpecs, orderSpecs);
  var flatNodes = [];
  flattenNodes(complexNodes, flatNodes, isVGrouping, [], 0, expansions, expansionDefault);
  return flatNodes;
}

function flattenNodes(complexNodes, res, isVGrouping, rowSpans, depth, expansions, expansionDefault) {
  for (var i = 0; i < complexNodes.length; i += 1) {
    var complexNode = complexNodes[i];
    var group = complexNode.group;

    if (group) {
      if (isVGrouping) {
        var firstRowIndex = res.length;
        var rowSpanIndex = rowSpans.length;
        flattenNodes(complexNode.children, res, isVGrouping, rowSpans.concat(0), depth, expansions, expansionDefault);

        if (firstRowIndex < res.length) {
          var firstRow = res[firstRowIndex];
          var firstRowSpans = firstRow.rowSpans = firstRow.rowSpans.slice();
          firstRowSpans[rowSpanIndex] = res.length - firstRowIndex;
        }
      } else {
        var id = group.spec.field + ':' + group.value;
        var isExpanded = expansions[id] != null ? expansions[id] : expansionDefault;
        res.push({
          id: id,
          group: group,
          isExpanded: isExpanded
        });

        if (isExpanded) {
          flattenNodes(complexNode.children, res, isVGrouping, rowSpans, depth + 1, expansions, expansionDefault);
        }
      }
    } else if (complexNode.resource) {
      var _id = complexNode.resource.id;

      var _isExpanded = expansions[_id] != null ? expansions[_id] : expansionDefault;

      res.push({
        id: _id,
        rowSpans: rowSpans,
        depth: depth,
        isExpanded: _isExpanded,
        hasChildren: Boolean(complexNode.children.length),
        resource: complexNode.resource,
        resourceFields: complexNode.resourceFields
      });

      if (_isExpanded) {
        flattenNodes(complexNode.children, res, isVGrouping, rowSpans, depth + 1, expansions, expansionDefault);
      }
    }
  }
}

function buildHierarchy(resourceStore, maxDepth, groupSpecs, orderSpecs) {
  var resourceNodes = buildResourceNodes(resourceStore, orderSpecs);
  var builtNodes = [];

  for (var resourceId in resourceNodes) {
    var resourceNode = resourceNodes[resourceId];

    if (!resourceNode.resource.parentId) {
      insertResourceNode(resourceNode, builtNodes, groupSpecs, 0, maxDepth, orderSpecs);
    }
  }

  return builtNodes;
}

function buildResourceNodes(resourceStore, orderSpecs) {
  var nodeHash = {};

  for (var resourceId in resourceStore) {
    var resource = resourceStore[resourceId];
    nodeHash[resourceId] = {
      resource: resource,
      resourceFields: buildResourceFields(resource),
      children: []
    };
  }

  for (var _resourceId in resourceStore) {
    var _resource2 = resourceStore[_resourceId];

    if (_resource2.parentId) {
      var parentNode = nodeHash[_resource2.parentId];

      if (parentNode) {
        insertResourceNodeInSiblings(nodeHash[_resourceId], parentNode.children, orderSpecs);
      }
    }
  }

  return nodeHash;
}

function insertResourceNode(resourceNode, nodes, groupSpecs, depth, maxDepth, orderSpecs) {
  if (groupSpecs.length && (maxDepth === -1 || depth <= maxDepth)) {
    var groupNode = ensureGroupNodes(resourceNode, nodes, groupSpecs[0]);
    insertResourceNode(resourceNode, groupNode.children, groupSpecs.slice(1), depth + 1, maxDepth, orderSpecs);
  } else {
    insertResourceNodeInSiblings(resourceNode, nodes, orderSpecs);
  }
}

function ensureGroupNodes(resourceNode, nodes, groupSpec) {
  var groupValue = resourceNode.resourceFields[groupSpec.field];
  var groupNode;
  var newGroupIndex; // find an existing group that matches, or determine the position for a new group

  if (groupSpec.order) {
    for (newGroupIndex = 0; newGroupIndex < nodes.length; newGroupIndex += 1) {
      var node = nodes[newGroupIndex];

      if (node.group) {
        var cmp = flexibleCompare(groupValue, node.group.value) * groupSpec.order;

        if (cmp === 0) {
          groupNode = node;
          break;
        } else if (cmp < 0) {
          break;
        }
      }
    }
  } else {
    // the groups are unordered
    for (newGroupIndex = 0; newGroupIndex < nodes.length; newGroupIndex += 1) {
      var _node = nodes[newGroupIndex];

      if (_node.group && groupValue === _node.group.value) {
        groupNode = _node;
        break;
      }
    }
  }

  if (!groupNode) {
    groupNode = {
      group: {
        value: groupValue,
        spec: groupSpec
      },
      children: []
    };
    nodes.splice(newGroupIndex, 0, groupNode);
  }

  return groupNode;
}

function insertResourceNodeInSiblings(resourceNode, siblings, orderSpecs) {
  var i;

  for (i = 0; i < siblings.length; i += 1) {
    var cmp = compareByFieldSpecs(siblings[i].resourceFields, resourceNode.resourceFields, orderSpecs); // TODO: pass in ResourceApi?

    if (cmp > 0) {
      // went 1 past. insert at i
      break;
    }
  }

  siblings.splice(i, 0, resourceNode);
}

function buildResourceFields(resource) {
  var obj = Object.assign(Object.assign(Object.assign({}, resource.extendedProps), resource.ui), resource);
  delete obj.ui;
  delete obj.extendedProps;
  return obj;
}

function isGroupsEqual(group0, group1) {
  return group0.spec === group1.spec && group0.value === group1.value;
}
/*
splits things BASED OFF OF which resources they are associated with.
creates a '' entry which is when something has NO resource.
*/


var ResourceSplitter = /*#__PURE__*/function (_Splitter2) {
  _inherits(ResourceSplitter, _Splitter2);

  var _super7 = _createSuper(ResourceSplitter);

  function ResourceSplitter() {
    _classCallCheck(this, ResourceSplitter);

    return _super7.apply(this, arguments);
  }

  _createClass(ResourceSplitter, [{
    key: "getKeyInfo",
    value: function getKeyInfo(props) {
      return Object.assign({
        '': {}
      }, props.resourceStore);
    }
  }, {
    key: "getKeysForDateSpan",
    value: function getKeysForDateSpan(dateSpan) {
      return [dateSpan.resourceId || ''];
    }
  }, {
    key: "getKeysForEventDef",
    value: function getKeysForEventDef(eventDef) {
      var resourceIds = eventDef.resourceIds;

      if (!resourceIds.length) {
        return [''];
      }

      return resourceIds;
    }
  }]);

  return ResourceSplitter;
}(Splitter);

export { AbstractResourceDayTableModel as A, DEFAULT_RESOURCE_ORDER as D, ResourceApi as R, VResourceJoiner as V, ResourceSplitter as a, ResourceDayHeader as b, ResourceDayTableModel as c, DayResourceTableModel as d, VResourceSplitter as e, flattenResources as f, getPublicId as g, handleResourceStore as h, isGroupsEqual as i, buildRowNodes as j, buildResourceFields as k, ResourceLabelContainer as l, parseResource as p, refineRenderProps$1 as r };